export default __webpack_public_path__ + "static/media/015-garlic.09143a80.svg";